export default __webpack_public_path__ + "static/media/CW__2975.6423fefc.jpeg";